/**
 * @generated SignedSource<<99a1a7e7bdec0d3e751612542bd53fba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkersCheckContentContainsStarlingImageContent$data = {
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "checkersCheckContentContainsStarlingImageContent";
};
export type checkersCheckContentContainsStarlingImageContent$key = {
  readonly " $data"?: checkersCheckContentContainsStarlingImageContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkersCheckContentContainsStarlingImageContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkersCheckContentContainsStarlingImageContent"
};

(node as any).hash = "232b30868e0186c7eb3a0321f4d71cea";

export default node;
